// import eventBus from '../../services/event-bus'
import Job from '../../models/job'

export default{
  namespaced: true,
  state: {
    jobs: []
  },
  getters: {
    all: state => state.jobs.map((d) => Job.rehydrate(d)),
    getById: (state, getters) => (id) => {
      const i = getters.all.findIndex((job) => job.getId() === id)
      return (i > 0) ? getters.all[i] : null
    },
    pending: (state, getters) => getters.all.filter((job) => job.isDue()),
    numPending: (state, getters) => getters.pending.length,
    anyPending: (state, getters) => getters.numPending > 0
  },
  mutations: {
    ADD (state, {job, replace}) {
      replace = replace === null ? false : replace
      const i = state.jobs.findIndex((j) => Job.rehydrate(j).getId() === job.getId())
      if (i > 0 && !replace) {
        return
      }
      state.jobs.push(job)
    },
    MARK_AS_RUN (state, job) {
      const i = state.jobs.findIndex((j) => Job.rehydrate(j).getId() === job.getId())
      if (i > 0) {
        state.jobs[i].run = true
        state.jobs[i].running = false
      }
    },
    MARK_AS_FAILED (state, job) {
      const i = state.jobs.findIndex((j) => Job.rehydrate(j).getId() === job.getId())
      if (i > 0) {
        state.jobs[i].attempts++
        state.jobs[i].running = false
      }
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js